import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Printer, Droplet } from "lucide-react";
import { portalApi } from "@/lib/portalApi";

export default function Certificate() {
  const [c, setC] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    portalApi.get("/portal/certificate").then((r) => setC(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  if (loading) return <p className="text-[#8a7a6a] font-body" data-testid="portal-certificate">Loading…</p>;

  if (!c?.completed) {
    return (
      <div data-testid="portal-certificate" className="max-w-xl">
        <h1 className="font-serif-display font-light text-4xl md:text-5xl mb-4">Graduation Certificate</h1>
        <div className="bg-white/60 border border-[#E0D8C9] rounded-xl p-8 text-center">
          <Droplet className="w-8 h-8 text-[#A9724E] mx-auto mb-4" strokeWidth={1.25} />
          <p className="font-serif-display text-2xl text-[#2A2825] mb-2">Not yet — keep pouring.</p>
          <p className="text-[#5E4B3C] font-body">Your certificate is prepared the moment your cohort completes all twenty-four weeks. It will be waiting here.</p>
          <Link to="/portal/journey" className="inline-block mt-6 text-sm text-[#A9724E] hover:underline">See your journey →</Link>
        </div>
      </div>
    );
  }

  return (
    <div data-testid="portal-certificate">
      <div className="flex items-center justify-between mb-6" data-print-hide>
        <h1 className="font-serif-display font-light text-3xl">Your certificate</h1>
        <button onClick={() => window.print()} data-testid="certificate-print" className="inline-flex items-center gap-2 rounded-full bg-[#A9724E] hover:bg-[#925C3B] text-[#F4EFE6] px-5 py-2.5 text-sm transition-colors">
          <Printer className="w-4 h-4" strokeWidth={1.5} />Print / Save as PDF
        </button>
      </div>

      <div id="certificate" className="mx-auto max-w-3xl bg-[#F7F2E9] p-3">
        <div className="border-2 border-[#C9A87E] p-1">
          <div className="border border-[#D8C6A8] px-8 py-14 md:px-16 md:py-20 text-center bg-[#FBF7EF]">
            <p className="tracking-[0.35em] text-[11px] uppercase text-[#A9724E] mb-8">Outpoured</p>
            <Droplet className="w-10 h-10 text-[#A9724E] mx-auto mb-8" strokeWidth={1} />
            <p className="tracking-overline text-xs uppercase text-[#8a7a6a] mb-4">Certificate of Completion</p>
            <p className="font-body text-[#5E4B3C] mb-2">This honors</p>
            <h2 className="font-serif-display text-4xl md:text-5xl text-[#2A2825] mb-6">{c.name}</h2>
            <p className="font-body text-[#5E4B3C] max-w-xl mx-auto leading-relaxed mb-10">
              for faithfully completing the six-month Outpoured journey — twenty-four weeks of being tipped over, emptied, and reformed, vessel to vessel.
            </p>
            <div className="flex items-center justify-center gap-10 mt-12">
              <div className="text-center">
                <p className="font-serif-display italic text-xl text-[#2A2825]">Dej</p>
                <div className="w-40 border-t border-[#C9A87E] mt-1 pt-1 tracking-overline text-[9px] uppercase text-[#8a7a6a]">Founder, Outpoured</div>
              </div>
              <div className="text-center">
                <p className="font-serif-display italic text-xl text-[#2A2825]">{c.date}</p>
                <div className="w-40 border-t border-[#C9A87E] mt-1 pt-1 tracking-overline text-[9px] uppercase text-[#8a7a6a]">{c.cohort} cohort</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
